import angular from 'angular';

import OrderDetailsComponent from './order-details.component';
import OrderDetailsController from './order-details.controller';

export default angular
  .module('order-details', [])
  .controller('OrderDetailsController', OrderDetailsController)
  .component('orderDetails', OrderDetailsComponent);



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/order-details/order-details.module.js